import React from "react";
import { Link, useLocation } from "react-router-dom";

const ContactButtons = () => {

    const location = useLocation();
  

  return (
    <div>
        {
        location.pathname !== "/thank-you"?
      
      <div className="contact-fix-buttons">
        <Link className="contact-fix-button-call"  target='"_blank'  to="tel:+919220407009" ><span><i className="fa-solid fa-phone-volume"></i></span></Link>
        <Link className="contact-fix-button-wa" target='"_blank'  to="https://wa.me/+919220407009?text=Hi, " ><i className="fa-brands fa-whatsapp"></i></Link>
      </div>
      :""}
    </div>
  );
};

export default ContactButtons;
